/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 28.35 grams, precisely 28.349523125 grams by the international definition of the pound. This is why kitchen scales and recipe conversions between US ounces/cups and grams almost never land on a perfectly round number — the underlying ratio simply isn't one.`)
};

const es_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 28.35 gramos, precisamente 28.349523125 gramos según la definición internacional de la libra. Por eso las básculas de cocina y las conversiones de recetas entre onzas/tazas estadounidenses y gramos casi nunca resultan en un número perfectamente redondo — la razón subyacente simplemente no es uno.`)
};

const de_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwa 28.35 Gramm, nach der internationalen Definition des Pfunds genau 28.349523125 Gramm. Deshalb landen Küchenwaagen und Rezeptumrechnungen zwischen US-Unzen/Cups und Gramm fast nie bei einer perfekt runden Zahl — das zugrunde liegende Verhältnis ist einfach keine.`)
};

const nl_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeveer 28,35 gram, precies 28.349523125 gram volgens de internationale definitie van de pond. Dit is waarom keukenweegschalen en receptconversies tussen Amerikaanse ounces/kopjes en gram haast nooit op een perfect rond getal uitkomen — de onderliggende verhouding is gewoon niet één.`)
};

const fr_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ 28,35 grammes, précisément 28,349523125 grammes par la définition internationale de la livre. C'est pourquoi les conversions de balances de cuisine et de recettes entre onces américaines/tasses et grammes ne se retrouvent presque jamais sur un nombre parfaitement rond — le rapport sous-jacent simplement ne l'est pas.`)
};

const it_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circa 28,35 grammi, precisamente 28,349523125 grammi secondo la definizione internazionale della libbra. Per questo motivo, le conversioni tra once/tazze USA e grammi su bilance da cucina e ricette quasi mai arrivano a un numero perfettamente rotondo — il rapporto sottostante semplicemente non è uno.`)
};

const pt_br2_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 28.35 gramas, precisamente 28.349523125 gramas pela definição internacional de libra. É por isso que balança de cozinha e conversões de receita entre onças/xícaras US e gramas quase nunca dão um número perfeitamente redondo — a proporção subjacente simplesmente não é uma.`)
};

const pt_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 28,35 gramas, precisamente 28,349523125 gramas pela definição internacional da libra. É por isto que as balanças de cozinha e as conversões de receitas entre onças/chávenas americanas e gramas quase nunca chegam a um número perfeitamente redondo — a razão subjacente simplesmente não é uma.`)
};

const ja_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`約28.35グラム。ポンドの国際定義により、正確に28.349523125グラムです。これが、台所スケールと米国オンス/カップとグラム間のレシピ変換が完全に丸い数に落ちることがない理由です — 基本的な比率が単純にそうではないからです。`)
};

const zh_uc_wt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq3_a", locale)
	if (locale === "en") return en_uc_wt_faq3_a(inputs)
	if (locale === "es") return es_uc_wt_faq3_a(inputs)
	if (locale === "de") return de_uc_wt_faq3_a(inputs)
	if (locale === "nl") return nl_uc_wt_faq3_a(inputs)
	if (locale === "fr") return fr_uc_wt_faq3_a(inputs)
	if (locale === "it") return it_uc_wt_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq3_a(inputs)
	if (locale === "pt") return pt_uc_wt_faq3_a(inputs)
	if (locale === "ja") return ja_uc_wt_faq3_a(inputs)
	return zh_uc_wt_faq3_a(inputs)
};